export function setLocalStorage(key: string, value: string | object) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getLocalStorage(key: string): string | null {
  const value = localStorage.getItem(key);
  return value ? (JSON.parse(value) as string) : null;
}

export function removeLocalStorage(key: string) {
  localStorage.removeItem(key);
}

export const getOrCreateLocalStorage = (key: string, makeDefault: () => string) => {
  const existingValue = localStorage.getItem(key);
  if (existingValue) {
    return existingValue;
  }

  const defaultValue = makeDefault();
  localStorage.setItem(key, defaultValue);

  return defaultValue;
};

export enum LocalStorageKeys {
  BACKOFF_DURATION = 'backoffDuration',
  BACKOFF_END = 'backoffEnd',
}
